import React from "react";
import { testSessionLoader } from "../../../loaders/helpers";
import { redirect, useLoaderData } from "react-router-dom";
import { contactList } from "../../../api/contact";
import TabLayout from "../../helpers/TabLayout";
import ContactsTable from "./ContactsTable";

const contactsTabLoader = async (params) => {
  await testSessionLoader(params);
  const url = new URL(params.request.url);
  let page = Number(url.searchParams.get("page"));
  page = isNaN(page) ? 0 : page;
  const contactListRes = await contactList(page);
  const contacts = contactListRes.data;
  if (!contacts.length && page !== 0) throw redirect("?page=0");
  return { contacts, page };
};

const ContactsTab = () => {
  const { contacts } = useLoaderData();
  let { page } = useLoaderData();

  const onPageButtonClicked = (newPage) => page = newPage;

  return (
    <TabLayout
      headerLabel="Contacts"
      skeletonLines={16}
    >
      <ContactsTable
        contacts={contacts}
        currentPage={page}
        onPageButtonClicked={onPageButtonClicked}
      />
    </TabLayout>
  );
};

export { contactsTabLoader };
export default ContactsTab;